// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"480":"122d071a","838":"e759c36a"}[chunkId] + ".js";
};